(function ($){
  "use strict";
  
  let dom = function() {
    return {
      btnFiltersMobile: $('.btn-filters-mobile'),
      backdropFilters: $('.backdrop-filters'),
      filterNavWrapper: $('.filter-nav-wrapper')
    }
  }
  
  $(document).ready(function() {
    initEvents();
  });
  
  function initEvents() {
    dom().btnFiltersMobile.on('click', function(ev) {
		dom().backdropFilters.addClass('show-filters');
      	dom().filterNavWrapper.addClass('show-filters');
	});
    
    dom().backdropFilters.on('click', function(ev) {
    	dom().backdropFilters.removeClass('show-filters');
      	dom().filterNavWrapper.removeClass('show-filters');
    });
  }
  
})(jQuery);